module.exports = __webpack_public_path__ + "img/behold-banner.e8f7a495.png";